import React from "react";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import NewPackage from "./newPackage";
// import PackageListItems from "./packageListItems";
import PackageListByStation from "./packageListByStation";
import PackageList from "./packageList";
import PackageChangeRequests from "scenes/packageChangeRequests";
import { user } from "localStorage";
import { hasPageAccess } from "utils/pagePermissions";

const Packages = () => {
  const tabItems = [
    {
      text: "New Package",
      component: <NewPackage />,
      slug: "packages/new",
    },
    {
      text: "Package list",
      component: <PackageList />,
      slug: "packages/list",
    },
    {
      text: "Stock",
      component: <PackageListByStation />,
      slug: "packages/stock",
    },
    {
      // Own page permission (packages/change-requests), not a tab slug of
      // "packages" — so roles keep the access they already have.
      text: "Change Requests",
      component: <PackageChangeRequests embedded />,
      key: "change-requests",
      visible: hasPageAccess(user(), "packages/change-requests"),
    },
  ];

  return (
    <PageShell title="Packages">
      <TabsNavigator tabItems={tabItems} pageSlug="packages" />
    </PageShell>
  );
};

export default Packages;
